// export const domain = "https://telzonmarketing-in.onrender.com";
export const domain = "https://telzonadmin.onrender.com";
